import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
// import { useDebounce } from 'use-debounce';
import Menu from '../../components/Menu/Menu';
import Footer from '../../components/Footer/Footer';
import TextEdit from '../../components/TextEdit/TextEdit';
import Toast from '../../components/Toast/Toast';
import { getFiliado } from '../../services/FiliadosService';
import SwitchInput from '../../components/SwitchInput/SwitchInput';


function EditFiliado(props) {
    const defaultLocation = useLocation();
    //  const location = useLocation();
    const params = useParams();
    const navigate = useNavigate();


    const [editUser, setEditUser] = useState({});
    const [count, setCount] = useState(0);

    const [notification, setNotification] = useState({ type: '', text: '' });
    const [error, setError] = useState('');
    const [dtfinal, setDtFinal] = useState('');


    const id = getId();

    useEffect(() => {
        const token = localStorage.getItem("token");


        getFiliado(id, token)
            .then(result => setEditUser(result))
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            })
    }, []);


    function getId(location) {
        if (!location) location = defaultLocation;
        return new URLSearchParams(location.search).get('id');
    }




    function onInputChange(event) {

        setEditUser(prevState => ({ ...prevState, [event.target.id]: event.target.value }));

    }



    function onFormSubmit(event) {
        setNotification({ type: 'success', text: `Settings updated successfully!` });

        // if ((settings.password || inputConfirmPassword.current.value)
        //     && settings.password !== inputConfirmPassword.current.value) {
        //     return setNotification({ type: 'error', text: 'The fields New Password and Confirm Password must be equals.' });
        // }

        // const token = localStorage.getItem('token');
        // updateSettings(settings, token)
        //     .then(result => {
        //         if (result)
        //             setNotification({ type: 'success', text: `Settings updated successfully!` });
        //         else
        //             setNotification({ type: 'error', text: `Can't update the settings.` });
        //     })
        //     .catch(error => {
        //         console.error(error.response ? error.response.data : error.message);
        //         setNotification({ type: 'error', text: `Can't update the settings.` });
        //     })
    }



    function getDate(timestamp) {

        const date = new Date(timestamp);

        try {
            return Intl.DateTimeFormat('pt-BR', {
                dateStyle: 'short',
                timeStyle: 'short'
            })
                .format(date);
        } catch (error) {
            console.log(error);
        }

    }
    useEffect(() => {

        const dataFinal = getDate(editUser.updatedAt);
        setDtFinal(dataFinal)

    })

    const data = dtfinal;


    return (
        <React.Fragment>
            <Menu />
            <main className="content">
                {/* Remaining JSX */}
                {/* Cabeçalho da página */}
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        {/* <h1 className="h4">Filiados...</h1> */}
                        
                    </div>
                  
                </div>

                {/* <h1 className="h4">3 - Pontos - Montar tela..</h1> */}

                <div className="row">
                    <div className="col-12">
                        <div className="card card-body border-0 shadow mb-4">
                            <h2 className="h5 my-4">Manutenção de cadastro</h2>
                            <div className="row">
                                {/* <TextEdit titulo="Nome:" name="nome" field={editBeacon.nome} placeholder="Nome dispositivo" onChange={onInputChange} size="3" ></TextEdit> */}
                                <TextEdit titulo="Nome:" name="nome" type="text" field={editUser.nome} placeholder="Nome e sobreenome" onChange={onInputChange} size="4" ></TextEdit>
                                <TextEdit titulo="Email:" name="email" type="text" field={editUser.email} placeholder="email@gmail.com" onChange={onInputChange} size="4" ></TextEdit>
                                <TextEdit titulo="Senha:" name="password" type="password" placeholder="entre com a senha" onChange={onInputChange} size="4" ></TextEdit>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <div className="form-group">

                                            <SwitchInput id="isActive" text="Is Active?" onChange={onInputChange} isChecked={(editUser.isActive)} />
                                        </div>
                                    </div>
                                </div>
                                <TextEdit titulo="Atualizado em:" name="updatedAt" field={data} placeholder="Atualizado" size="3" />
                                {/* <div className="row">
                                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap">
                                        <div className="col-sm-3">
                                            <button className="btn btn-gray-800 mt-2 animate-up-2" type="button" onClick={onFormSubmit}>Save</button>
                                        </div>
                                    </div>
                                </div> */}

                                <div className="modal-footer">
                                  
                                    <button className="btn btn-gray-800 mt-2 animate-up-2" type="button" onClick={onFormSubmit}>Save</button>
                                </div>
                            </div>
                        </div>




                    </div>
                </div>
                {/* Rodape da página */}
                <Footer />
            </main>
            {/* <UserModal data={editUser} onSubmit={onModalSubmit} /> */}
            <Toast type={notification.type} text={notification.text} />
        </React.Fragment>
    );
}

export default EditFiliado;
